import script from "./OfferTag.vue?vue&type=script&lang=ts&setup=true"
export * from "./OfferTag.vue?vue&type=script&lang=ts&setup=true"

import "./OfferTag.vue?vue&type=style&index=0&id=07427de5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07427de5"]])

export default __exports__